import React, { useEffect, useState } from 'react';
import { Card, CardContent, Typography, Box, Divider, CardMedia, Grid, Button, IconButton, Icon, useTheme } from '@mui/material';
import styled from '@emotion/styled';
import AttachMoneyRoundedIcon from '@mui/icons-material/AttachMoneyRounded';
import ContentCutRoundedIcon from '@mui/icons-material/ContentCutRounded';

import { formatGenericDate, formatCurrency } from '../../../utils/util';

import { SectionHeaderBar, BasicFlex, LabelUpper, autoCompleteDisplayLabel, DotSeparator } from '../../../utils/Common';

import { useFormikContext, FieldArray } from 'formik';

import { useFormData } from '../../../contexts/FormData';

import Field from '../../../utils/FormikFields/Field';

import Dialog from '../../../utils/utilities/Dialog';

import useCustomOrderStore from '../../../store/custom_orders';

import EditRepairTicket from '../../Repair_Tickets/EditRepairTicket';

import EditWigOrder from '../../WigOrders/EditWigOrder';

// linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%);

const Container = styled.div`
  background-color: ${props => props.theme.colors.softBg};
  border-radius: 5px;
  padding: 1.5rem 1rem;
`

const SearchContainer = styled.div`
  margin: 1rem 0;
`

const ProductListContainer = styled(BasicFlex)`
  margin: 1.5rem 0;
  width: 100%;
  gap: 1rem;
`;

const StyledCard = styled(Card)`
 border-radius: 8px;
 border: 1px solid ${props => props.theme.colors.border};
 box-shadow: 0 1px 5px rgba(0, 0, 0, 0.12);
 transition: all 0.2s ease-in-out;
 overflow: hidden;
 
 &:hover {
   border-color: ${props => props.theme.colors.darkBg};
   box-shadow: 0 2px 8px rgba(25, 118, 210, 0.1);
 }
`;

const ServiceItemDetails = styled(BasicFlex)`
  /* min-width: fit-content; */
  /* width: auto; */
  margin-right: 4rem;
`;

const ServiceTitle = styled.div`
  text-transform: uppercase;
  font-weight: 600;
  font-size: 1.4rem;
  /* color: ${props => props.theme.colors.mildText}; */
  /* margin-bottom: .5rem; */
`

const DetailLineStyles = styled.div`
  /* font-size: 1.4rem; */
  color: ${props => props.theme.colors.mildText};
`;

const PriceDisplay = styled(BasicFlex)`
 width: fit-content;
 .MuiInputBase-input {
    padding: .2rem !important;
  }
`

const SaveConfirmation = styled.div`
  padding: 1.6rem;
`

const ServiceActions = styled(BasicFlex)`
`;

// const AddRepairs = () => {

//   const [openCODialog, setOpenCODialog] = useState(false);

//   const { values, submitForm } = useFormikContext() || {};

//   const { formValues } = useFormData() || {};

//   const pendingCODialog = useCustomOrderStore((state) => state.pendingCODialog);
//   const setPendingCODialog = useCustomOrderStore((state) => state.setPendingCODialog);
//   const setInvoiceData = useCustomOrderStore((state) => state.setInvoiceData);

//   let is_edit = !!values?.invoice_id;

//   let invoice_data = {
//     invoice_id: values?.invoice_id,
//     customer_id: values?.customer_id,
//     customer_name: formValues?.client_name || values?.client_name,
//     appointment_id: values?.appointment_id,
//     order_type: "custom"
//   }

//   let id = `${values?.customer_id?.toString()}-co`

//   const saveInvoice = () => {
//     setPendingCODialog(id);
//     submitForm();
//   }

//   useEffect(() => {
//     if (is_edit && pendingCODialog === id) {
//       setOpenCODialog(true);
//       setInvoiceData(invoice_data);
//     }
//   }, [is_edit, pendingCODialog])

//   return (
//     <>
//     <Dialog
//       title="Confirm Save Invoice"
//       key="confirm-save-invoice"
//       disabled={!values?.customer_id}
//       toggle={(
//       <Button 
//         startIcon={<ContentCutRoundedIcon />} 
//         variant="contained" 
//         size="large" 
//         color="info" 
//         disabled={!values?.customer_id}
//       >Add Custom Order</Button>
//       )}
//       saveText="Save Invoice"
//       saveFunc={saveInvoice}
//     >
//       <SaveConfirmation>
//         To Proceed to Custom Orders, you must first save the invoice. Hit save to confirm.
//       </SaveConfirmation>
//     </Dialog>

//     <Dialog
//       title="Add Custom Order"
//       key="add-custom-order"
//       forceOpen={openCODialog}
//       forceClose={() => setOpenCODialog(false)}
//       fullScreen
//       useForm={true}
//     >
//       <EditWigOrder dialog={true} appt_info={invoice_data} ignore_id={true} />
//       {/* <EditRepairTicket dialog={true}/> */}
//     </Dialog>
//     </>
//   )
// }


const CustomOrderLine = ({ li = {}, index, remove }) => {
  const { values } = useFormikContext() || {};
  let { name, sku, description } = li;

  const theme = useTheme();

  return (
    <StyledCard sx={{p: ".6rem !important", width: "100%", border: `1px solid ${theme.palette.info.main} !important`, borderRadius: "2px !important"}} variant='outlined'>
      <BasicFlex justify="flex-start">
        <CardContent sx={{p: ".5rem 1.6rem !important", width: "100%"}}>
         <BasicFlex justify="space-between">
         
          <ServiceItemDetails dir="column" gap=".5rem" align="flex-start">
            <ServiceTitle>{name}</ServiceTitle>
            <DetailLineStyles>{description}</DetailLineStyles>
          </ServiceItemDetails>

          <ServiceActions align="flex-end" justify="flex-end" gap="1rem">
          <PriceDisplay>
             <Field name={`custom_orders.${index}.rate`} type="number" InputProps={{sx: {margin: 0, width: "10rem", paddingLeft: ".5rem !important", fontSize: "1.6rem", fontWeight: "500", gap: ".5rem"}, startAdornment: <AttachMoneyRoundedIcon fontSize='small' />}} />
            </PriceDisplay>
          </ServiceActions>
         </BasicFlex>
        </CardContent>
      </BasicFlex>
      
    </StyledCard>
  )
}

const Repairs = () => {
  const { values } = useFormikContext() || {};

  let custom_orders = values?.custom_orders || [];

  return (
    custom_orders.length ? <Grid size={{xs: 12}}>
       <Container>
        <LabelUpper>Custom Orders</LabelUpper>
        
          <FieldArray name="wigs">
            {({ push, remove }) => (
              <>
                <ProductListContainer dir="column">
                { custom_orders.map((co, index) => (
                    <CustomOrderLine key={index} li={co} index={index} remove={remove} />
                  ))}
                </ProductListContainer>

              {/* <AddRepairs /> */}
              </>
            )}
          </FieldArray>
      </Container>
    </Grid> : null
  )
};

export default Repairs;